import { trackEvent } from 'user-analytics';
import { SEAT_TAPPED } from 'constants/TrackEvents';

/**
 * Tracks when the adjacent dialog is opened.
 */
export function trackOpenAdjacentDialog() {
  trackEvent('Adjacent Dialog Opened');
}

/**
 * Tracks when the adjacent dialog is closed.
 */
export function trackCloseAdjacentDialog() {
  trackEvent('Adjacent Dialog Closed');
}

/**
 * Tracks when user taps a seat in seat diagram.
 * @param {Object} payload - Tap event payload.
 * @param {number} payload.seatNumber - Tapped seat number.
 * @param {number} payload.seatFloor - Tapped seat floor.
 * @param {string} payload.fareType - Tapped seat fare type (seatFareReference or seatFareDescription).
 * @param {number} payload.fareAmount - Tapped seat fare amount.
 * @param {number} payload.tapIndex - Tap index for current seat diagram session.
 * @param {string} payload.action - Selected or Deselected.
 * @param {string} payload.screen - Schedule screen or Checkout breadcrumb.
 * @param {string} payload.departureRoute - Departure route.
 */
export function trackSeatTapped({
  seatNumber,
  seatFloor,
  fareType,
  fareAmount,
  tapIndex,
  action,
  screen,
  departureRoute,
}) {
  trackEvent(SEAT_TAPPED, {
    'Seat number': Number(seatNumber) || 0,
    'Seat floor': Number(seatFloor) || 1,
    'Fare type': fareType || 'General',
    'Fare amount': Number(fareAmount) || 0,
    'Tap index': Number(tapIndex) || 0,
    'Action': action || '',
    'Screen': screen || '',
    'Departure route': departureRoute || '',
  });
}
